// @flow

import type { State } from "@store/reducers";
import type { ApprovableContainer, HierarchyAssignment } from "@modules/service/types";
import type { Rtw, RTWProcessesData, RTWFilterStateType } from "@modules/service/reducer/rtw/types";
import { validateHierarchyAssignmentSchema } from "./index";

export type GetRtwListType = (state: State) => Array<Rtw>;

// RTW CRUD

export const getRTWLiveProcessesFilter = (state: State): RTWFilterStateType =>
  state.service.rtw.liveProcessesFilter;

export const getRTWDraftProcesses = (state: State): RTWProcessesData =>
  state.service.rtw.draftProcesses;

export const getRTWPendingProcesses = (state: State): RTWProcessesData =>
  state.service.rtw.pendingProcesses;

export const getRTWLiveProcesses = (state: State): RTWProcessesData =>
  state.service.rtw.liveProcesses;

export const getCurrentRtw = (state: State): ?ApprovableContainer<Rtw> => state.service.rtw.current;

export const getRtwDraft = (state: State): ?Rtw => state.service.rtw.draft;

export const getRtwAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.rtw.assignments;

export const getRtwDraftAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.rtw.draftAssignments;

export const isRtwDraftAssignmentsValid = (state: State): boolean => {
  const assignments = getRtwDraftAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const isRtwAssignmentsValid = (state: State): boolean => {
  const assignments = getRtwAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

// RTW SCHEMA

export const getRtwSchema = (state: State): Object | null => state.service.rtw.schema;

// RTW CONFIG

export const getRtwEnabled = (state: State): boolean => state.service.rtw.configuration.enabled;

export const getRtwStatus = (state: State) => state.service.rtw.configuration.status;

// RTW MODALS

export const getRtwModalStep = (state: State): number => state.service.rtw.modals.modalStep;

export const getShowRtwAddModal = (state: State): boolean => state.service.rtw.modals.showAddModal;

export const getShowRtwEditModal = (state: State): boolean =>
  state.service.rtw.modals.showEditModal;

export const getShowRtwEditAssignmentsModal = (state: State): boolean =>
  state.service.rtw.modals.showEditAssignmentsModal;

export const getShowRtwDiscardModal = (state: State): boolean =>
  state.service.rtw.modals.showDiscardModal;

export const getShowRtwSubmitModal = (state: State): boolean =>
  state.service.rtw.modals.showSubmitModal;

export const getShowRtwCancelModal = (state: State): boolean =>
  state.service.rtw.modals.showCancelModal;

export const getShowRtwCancelDiscardModal = (state: State): boolean =>
  state.service.rtw.modals.showCancelDiscardModal;

export const getShowRtwDisableModal = (state: State): boolean =>
  state.service.rtw.modals.showDisableModal;

export const getShowRtwAddAttachmentModal = (state: State): boolean =>
  state.service.rtw.modals.showAddRtwAttachmentModal;

export const getAddFileInProgress = (state: State): boolean => {
  return state.service.rtw.addFileInProgress;
};
